import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setWasPatientImmboilizedOutcomeOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getWasPatientImmOutcome() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      optionsService,
      optionsService.getWasPatientImmobilizedOutcomeOptions,
    ])
    const { entity } = response
    yield put(setWasPatientImmboilizedOutcomeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getWasPatientImmOutcome() error: ${e}`))
  }
}
export function* getWasPatientImmOutcomeSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getWasPatientImmOutcome)
}
